<template>
    <v-select
        :name="name"
        :class="{'prefixed-dropdown': prefixed, 'postpended-dropdown': postpended, 'is-invalid': error}"
        :options="choices"
        :required="required"
        :disabled="disabled"
        :value="displayValue"
        label="caption"
        @input="handleInput($event)"
    />
</template>

<script>
    const EVENTS = {
        INPUT: 'input',
    }

    export default {
        name: 'select-input',
        props: {
            // Choices format: [{caption: <value to display>, value: <value to save>}...]
            name: {type: String, required: true},
            choices: {type: Array, required: true},
            error: {type: String},
            value: {default: ''},
            required: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            prefixed: {type: Boolean, default: false},
            postpended: {type: Boolean, default: false},
        },
        computed: {
            displayValue,
        },
        methods: {
            handleInput,
        },

    };

    function displayValue() {
        const choice = this.choices.find(choice => choice.key === this.value);
        if (choice) {
            return choice;
        }
        if (this.value) {
            return {caption: this.value, key: this.value};
        }
        // v-select does not recognize choice with empty caption, need to return empty string as a value.
        return '';
    }

    function handleInput(choice) {
        this.$emit(EVENTS.INPUT, choice ? choice.key : null);
    }

</script>
